export default __webpack_public_path__ + "static/collage-2-e272c86a7b977edc17abb7022132b941.jpg";